<template>
  <div class="Add">
    <div class="row row1 clear">
      <i class="iconfont icon-shijian"></i>
      <span class="item">{{time}}</span>
    </div>
    <div class="row row2 clear">
      <i class="iconfont icon-yuan"></i>
      <span class="text">{{origin}}</span>
    </div>
    <div class="waypoint">
      <div class="row clear" v-for="(item,index) in waypoint" :class="item.arrive?'arrive':''">
        <i class="iconfont icon-yuan1"></i>
        <span class="text">{{item.address}}</span>
      </div>
    </div>
    <div class="row row3 clear">
      <i class="iconfont icon-yuan"></i>
      <span class="text">{{endPoint}}</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'xk-Add',
    props: ['endPoint', 'origin', 'time', 'waypoint'],
    data () {
      return {}
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .Add {
    background-color: #fff;
    padding: 1rem 2rem;
    .row {
      height: 2.5rem;
      line-height: 2.5rem;
      font-size: 1.25rem;
      i {
        margin-right: 0.5rem;
        float: left;
      }
      .text {
        display: inherit;
        width: calc(~'100% - 2rem');
        overflow: hidden;
        text-overflow: ellipsis;
        height: 2rem;
      }
    }
    .row1 {
      color: #333;
      height: 2.6rem;
      line-height: 2.6rem;
      i {
        display: inline-block;
        height: 2.6rem;
        line-height: 2.6rem;
        font-size: 1rem;
        color: #fab10a;
      }
    }
    .row2, .row3 {
      font-size: 1.2rem;
      color: #999999;
      i {
        display: inline-block;
        height: 2rem;
        line-height: 2rem;
        font-size: 1rem;
      }
    }
    .row2 {
      i {
        color: #3cafb9;
      }
    }
    .row3 {
      i {
        color: #f06553;
      }
    }
    .waypoint {
      .row {
        position: relative;
        i {
          margin-left: -0.1rem;
          color: #999;
          position: relative;
          z-index: 5;
          transition: 0.3s all;
        }
        .text {
          color: #999999;
          margin-left: -0.2rem;
        }
      }
      .row::after {
        content: '';
        background: #E8E8E8;
        height: 185%;
        width: 1px;
        position: absolute;
        left: 0.45rem;
        top: 50%;
        transform: translate(0, -50%);
        transition: 0.3s all;
      }
      .row:nth-last-child(1)::after {
        height: 135%;
      }
      .arrive {
        i {
          color: #00c801;
        }
      }
      .arrive::after {
        background: #1E2021;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// add.vue?5e3191a5